import React, { useRef, useEffect } from "react";
import "../SimulatorInfo.css";
import SvgLines from "react-mt-svg-lines";

let mounted;

export default function CenterFc({ pageJSON, simPageNum }) {
  useEffect(() => {
    let time;
    if (document.getElementById("fading-screen-image-FC")) {
      document
        .getElementById("fading-screen-image-FC")
        .classList.add("img-fade-out");
      document.getElementById("fading-screen-image-FC").style.opacity = 1;
      time = setTimeout(() => {
        document
          .getElementById("fading-screen-image-FC")
          .classList.remove("img-fade-out");
        document.getElementById("fading-screen-image-FC").style.opacity = 0;
      }, 500);
      return () => {
        clearTimeout(time);
      };
    }
  }, [simPageNum]);

  // const vidRef = useRef();
  // useEffect(() => {
  //   setTimeout(function () {
  //     if (vidRef.current) {
  //       vidRef.current.play();
  //     }
  //   }, 1000);
  // }, [vidRef.current]);

  //25%
  //40%
  //50%
  //67%
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const myLoop = async (time, arr) => {
    for (let i = 0; i < arr.length; i++) {
      if (mounted && document.getElementById("the-scroll-screen")) {
        document.getElementById(
          "the-scroll-screen"
        ).style.transform = `translateY(-${arr[i]})`;
        if (i === 0) {
          await sleep(500);
        } else {
          await sleep(1000);
        }
      } else {
        break;
      }
    }
  };
  useEffect(() => {
    let time;
    mounted = true;
    if (document.getElementById("the-scroll-screen")) {
      const arr = ["0%", "25%", "40%", "54%", "67%"];
      myLoop(time, arr);
    }

    return () => {
      mounted = false;
      clearTimeout(time);
    };
  }, []);
  return (
    <div className="center-fc">
      {pageJSON[simPageNum].center_image_data.img_title ? (
        <div
          className="cfc-inner"
          style={{
            height: "auto",
            left: "-20px",
            justifyContent:
              pageJSON[simPageNum].center_image_data.img_title_pos,
          }}
        >
          <p
            style={{
              ...pageJSON[simPageNum].center_image_data.img_title_style,
            }}
          >
            {pageJSON[simPageNum].center_image_data.img_title}
          </p>
        </div>
      ) : null}
      <div className="cfc-inner">
        <img
          alt=""
          src={pageJSON[simPageNum].center_image_data.src}
          style={{
            position: "absolute",
            left: "-20px",
            height: "auto",
            width: "100%",
            zIndex: "200",
          }}
        />

        {/* {pageJSON[simPageNum].center_image_data.black_screen ? (
					<img
						alt="power-off"
						src="./images/emulator/power-off-2.png"
						style={{
							position: "absolute",
							top: pageJSON[simPageNum].center_image_data.bezel_video.top,
							left: pageJSON[simPageNum].center_image_data.bezel_video.left,
							height: "300px",
							width: "40%",
							zIndex: "190",
						}}
					/>
				) : null} */}
        {pageJSON[simPageNum].center_image_data.svg ? (
          <>
            <SvgLines animate={1000} stagger={150} duration={3000}>
              <svg
                style={{
                  top: "405px",
                  left: "124px",
                  height: pageJSON[simPageNum].center_image_data.height,
                  width: "auto",
                  transformOrigin: pageJSON[simPageNum].center_image_data
                    .transform_origin
                    ? pageJSON[simPageNum].center_image_data.transform_origin
                    : "center",
                  position: "absolute",
                  zIndex: "200",
                }}
              >
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M17.2,199.1v-22.4c0-14.1,11.5-25.6,25.6-25.6h0 c14.1,0,25.6,11.5,25.6,25.6v22.4c0,14.1-11.5,25.6-25.6,25.6h0C28.6,224.7,17.2,213.3,17.2,199.1z"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M60.4,160.3L149,14.7h274.4"
                />
                <path
                  fill="none"
                  stroke="#BF0C3F"
                  stroke-width="4"
                  stroke-miterlimit="10"
                  d="M69.7,187.9l96.8-27.6h256.9"
                />
                <circle fill="#BF0C3F" cx="419.5" cy="14.7" r="7.4" />
                <circle fill="#BF0C3F" cx="419.5" cy="160.3" r="7.4" />
              </svg>
            </SvgLines>
            <img
              alt=""
              src="./images/thinq-logo-3.png"
              style={{
                height: "80px",
                width: "auto",
                position: "absolute",
                top: "380px",
                left: "430px",
              }}
            />
            <img
              alt=""
              src="./images/alexa-logo-2.svg"
              style={{
                height: "80px",
                width: "auto",
                position: "absolute",
                top: "525px",
                left: "430px",
              }}
            />
          </>
        ) : null}
        {pageJSON[simPageNum].center_image_data.bezel_screen ? (
          <img
            src={pageJSON[simPageNum].center_image_data.bezel_screen.src}
            alt=""
            style={{
              position: "absolute",
              top: "0.25%",
              left: "-20px",
              height: "auto",
              width: "99.6%",
              zIndex: "100",
            }}
          />
        ) : null}
        {pageJSON[simPageNum].center_image_data.bezel_screen &&
        pageJSON[simPageNum].center_image_data.bezel_screen.fade ? (
          <img
            src={pageJSON[simPageNum].center_image_data.bezel_screen.fade}
            alt=""
            id="fading-screen-image-FC"
            style={{
              position: "absolute",
              top: "0.25%",
              left: "-20px",
              height: "auto",
              width: "99.6%",
              zIndex: "100",
            }}
          />
        ) : null}
        {pageJSON[simPageNum].center_image_data.bezel_video ? (
          <div
            id="scroll-screen"
            style={{
              position: "absolute",
              width: "99.6%",
              backgroundColor: "black",
              overflow: "hidden",
              pointerEvents: "all",
              height: "0px",
              left: "-20px",
              paddingBottom: "56.25%",
            }}
          >
            <img
              id="the-scroll-screen"
              width="100%"
              style={{
                transition: "transform .5s",
                pointerEvents: "all",
              }}
              src={"./images/screens/home-scroll.jpg"}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
